import { TFunction } from 'i18next'

import { GetInvestigationHierarchyResponse } from 'src/api/requests'

import { InvestigationHierarchyNode } from '../types'

type Props = {
  item?: GetInvestigationHierarchyResponse
  lang: 'ro' | 'ru'
  t: TFunction
}

export const normalizeInvestigationHierarchy = ({
  item,
  lang,
  t
}: Props): InvestigationHierarchyNode[] => {
  if (!item?.id) return []

  const categoryNodes: InvestigationHierarchyNode[] =
    item?.investigationCategories?.map((category) => ({
      label: category.translation?.[lang] ?? '',
      value: JSON.stringify({
        institutionId: item.id,
        categoryId: category.id
      })
    })) ?? []

  const institutionNode: InvestigationHierarchyNode = {
    label: item.name ?? '',
    value: item.id,
    children: categoryNodes
  }

  const childNodes =
    item?.children?.flatMap((child) =>
      normalizeInvestigationHierarchy({ item: child, lang, t })
    ) ?? []

  return institutionNode ? [institutionNode, ...childNodes] : [...childNodes]
}
